import { connect } from "react-redux";
import ProviderProfile from "./profile";
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import MainTemplate from "../../mainTemplate";
import Modal from "../../../utils/customModal";
import { subString, loadingHtml } from "../../../utils/functions";
import * as ProviderActions from "../../../../Redux/actions/providerActions";

export class ProviderTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = { modal: true, contentReady: false, provider: {} };
  }

  componentDidMount() {
    const {
      match: { params },
      actions: { getProviderCSAById },
    } = this.props;
    return getProviderCSAById(params.providerId).then((response) => {
      this.setState({ provider: response.data, contentReady: true });
    });
  }

  componentWillUnmount() {
    this.setState({ contentReady: false, provider: {} });
  }

  headerTabTitle(providerName) {
    return (
      <div className="providerName">
        <span title={providerName}>
          Proveedor: <b>{subString(providerName, 20)}</b>{" "}
        </span>
      </div>
    );
  }

  render() {
    const { provider, contentReady } = this.state;

    return (
      <MainTemplate>
        {contentReady ? (
          <React.Fragment>
            <div className="provider-profile">
              <ProviderProfile provider={provider} />
            </div>
          </React.Fragment>
        ) : (
          <Modal show={this.state.modal}>{loadingHtml()}</Modal>
        )}
      </MainTemplate>
    );
  }
}

export const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(ProviderActions, dispatch),
  };
};

export default withRouter(
  connect(
    null,
    mapDispatch
  )(ProviderTemplate)
);
